import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const documentDocumentRelationDataClassName =
  DataClassName.DOCUMENT_DOCUMENT_RELATION
const documentDocumentRelationEndpoint = PisaDataClassEndpoint.DOCUMENT_DOCUMENT

export function pisaDocumentDocumentRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(documentDocumentRelationDataClassName, {
    title: documentDocumentRelationDataClassName,
    restApi: createPisaRestApiConfig(documentDocumentRelationEndpoint),
    attributes,
  })
}
